const styles = theme => ({
  base: theme.loginBase,
  '@media (max-width:767px)':{
    display:'block'
  },
})

export default styles
